export const MunhnaErc20 = {
  _format: "hh-sol-artifact-1",
  contractName: "Munhna_ERC20",
  sourceName: "contracts/MunhnaERC20.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "string",
          name: "name",
          type: "string"
        },
        {
          internalType: "string",
          name: "symbol",
          type: "string"
        },
        {
          internalType: "uint256",
          name: "supplyCap",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "lockPeriod",
          type: "uint256"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "unlockedBalance",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "minRequired",
          type: "uint256"
        }
      ],
      name: "InsufficientUnlockedTokens",
      type: "error"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "required",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "balance",
          type: "uint256"
        }
      ],
      name: "LockAmountExceedsBalance",
      type: "error"
    },
    {
      inputs: [],
      name: "LockingPeriodZero",
      type: "error"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "maximumMintable",
          type: "uint256"
        }
      ],
      name: "MintExceedsSupplyCap",
      type: "error"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "min",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "max",
          type: "uint256"
        }
      ],
      name: "SupplyCapOutOfRange",
      type: "error"
    },
    {
      inputs: [],
      name: "TokenManagerZero",
      type: "error"
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "min",
          type: "uint8"
        },
        {
          internalType: "uint8",
          name: "max",
          type: "uint8"
        }
      ],
      name: "TokenNameLengthOutOfRange",
      type: "error"
    },
    {
      inputs: [
        {
          internalType: "uint8",
          name: "min",
          type: "uint8"
        },
        {
          internalType: "uint8",
          name: "max",
          type: "uint8"
        }
      ],
      name: "TokenSymbolLengthOutOfRange",
      type: "error"
    },
    {
      inputs: [],
      name: "UnlockableBalanceZero",
      type: "error"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Approval",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "bytes32",
          name: "previousAdminRole",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "bytes32",
          name: "newAdminRole",
          type: "bytes32"
        }
      ],
      name: "RoleAdminChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        }
      ],
      name: "RoleGranted",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "sender",
          type: "address"
        }
      ],
      name: "RoleRevoked",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "TokenLocked",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "TokenUnlocked",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "Transfer",
      type: "event"
    },
    {
      inputs: [],
      name: "DEFAULT_ADMIN_ROLE",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "LOCK_PERIOD",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "SUPPLY_CAP",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "TOKEN_MANAGER_ADMIN_ROLE",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "TOKEN_MANAGER_ROLE",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        }
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "subtractedValue",
          type: "uint256"
        }
      ],
      name: "decreaseAllowance",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        }
      ],
      name: "getRoleAdmin",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "grantRole",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "hasRole",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "addedValue",
          type: "uint256"
        }
      ],
      name: "increaseAllowance",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "lockedBalanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "balance",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "mintAndLock",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "renounceRole",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "role",
          type: "bytes32"
        },
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "revokeRole",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceId",
          type: "bytes4"
        }
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "unlock",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        }
      ],
      name: "unlockableBalanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "unlockableBalance",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ],
  bytecode: "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",
  deployedBytecode: "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",
  linkReferences: {},
  deployedLinkReferences: {}
}
